
import { useTransactionData } from "./transactions/useTransactionData";
import { useSummaryCalculations } from "./transactions/useSummaryCalculations";
import { PaymentSummary } from "@/components/counting/types/PaymentTypes";
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useQueryClient } from "@tanstack/react-query";

export const usePaymentSummaries = (period: string, startDate?: Date) => {
  const { data, isLoading: isTransactionsLoading } = useTransactionData(period, startDate);
  const { calculateSummaries } = useSummaryCalculations();
  const [summaries, setSummaries] = useState<PaymentSummary[]>([]);
  const queryClient = useQueryClient();

  // Configuration des mises à jour en temps réel
  useEffect(() => {
    console.log("Setting up realtime subscription for transactions");
    
    const channel = supabase
      .channel('transactions-changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'poultry_transactions'
        },
        (payload) => {
          console.log("Transaction change detected:", payload);
          queryClient.invalidateQueries({ queryKey: ["transactions"] });
        }
      )
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'validated_amounts'
        },
        (payload) => {
          console.log("Validated amounts change detected:", payload);
          queryClient.invalidateQueries({ queryKey: ["validatedAmounts"] });
        }
      )
      .subscribe((status) => {
        console.log("Realtime subscription status:", status);
      });

    return () => {
      console.log("Cleaning up realtime subscription");
      supabase.removeChannel(channel);
    };
  }, [queryClient]);

  useEffect(() => {
    if (data) {
      console.log("Raw transaction data:", data);
      const processedSummaries = calculateSummaries(data);
      console.log("Processed summaries:", processedSummaries);
      setSummaries(Array.isArray(processedSummaries) ? processedSummaries : []);
    }
  }, [data, calculateSummaries]);

  return {
    summaries,
    isLoading: isTransactionsLoading,
  };
};
